import {Ingrediente} from "./Ingrediente";

export class IngredienteSezioneAggiuntiva {
    private _ingrediente: Ingrediente;
    private _quantita?: number;
    private _prezzo: number;

    constructor() {
        this._ingrediente = Ingrediente.createEmpty();
        this._quantita = 0;
        this._prezzo = 0;
    }

    static async convertFromFirestore(data: any) {
        let ingredienteSezioneAggiuntiva = new IngredienteSezioneAggiuntiva();
        ingredienteSezioneAggiuntiva.quantita = data.quantita;
        ingredienteSezioneAggiuntiva.prezzo = data.prezzo;
        let ingredienteReference = await data.ingrediente_reference.get();
        ingredienteSezioneAggiuntiva.ingrediente = await Ingrediente.convertFromFirestore(ingredienteReference.id, await ingredienteReference.data());
        ingredienteSezioneAggiuntiva.ingrediente.id = ingredienteReference.id;
        return ingredienteSezioneAggiuntiva;
    }

    get ingrediente(): any {
        return this._ingrediente;
    }

    set ingrediente(value: any) {
        this._ingrediente = value;
    }

    get quantita(): number | undefined {
        return this._quantita;
    }

    set quantita(value: number | undefined) {
        this._quantita = value;
    }

    get prezzo(): number {
        return this._prezzo;
    }

    set prezzo(value: number) {
        this._prezzo = value;
    }
}